"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.std_scaler = void 0;
var sum_1 = require("./sum");
/**
 * Standardize features by removing the mean and scaling to unit variance
 * The standard score of a sample x is calculated as:
 * z = (x - u) / s
 * @see https://scikit-learn.org/stable/modules/generated/sklearn.preprocessing.StandardScaler.html
 * @param matrix2D
 */
var std_scaler = function (matrix2D) {
    var scaled_array = [];
    var _loop_1 = function (row) {
        var scaled_row = [];
        var column_index = 0;
        var _loop_2 = function (item) {
            var column = matrix2D.map(function (inner_row) { return inner_row[column_index]; });
            var u = sum_1.default(column) / column.length;
            var std_dev_inside = matrix2D.map(function (inner_row) { return Math.pow(Math.abs(inner_row[column_index] - u), 2); });
            var s = Math.sqrt(sum_1.default(std_dev_inside) / matrix2D.length);
            scaled_row.push((item - u) / s);
            column_index++;
        };
        for (var _i = 0, row_1 = row; _i < row_1.length; _i++) {
            var item = row_1[_i];
            _loop_2(item);
        }
        scaled_array.push(scaled_row);
    };
    for (var _i = 0, matrix2D_1 = matrix2D; _i < matrix2D_1.length; _i++) {
        var row = matrix2D_1[_i];
        _loop_1(row);
    }
    return scaled_array;
};
exports.std_scaler = std_scaler;
exports.default = exports.std_scaler;
